import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.182 9.143h5.09v1.143h-5.09zM3.182 6.286h7.636v1.142H3.182zM3.182 12h3.181v1.143H3.182z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.727 1.714h-1.909v-.571c0-.303-.134-.594-.373-.808a1.35 1.35 0 0 0-.9-.335h-5.09c-.338 0-.662.12-.9.335a1.09 1.09 0 0 0-.373.808v.571h-1.91c-.337 0-.66.12-.9.335A1.09 1.09 0 0 0 0 2.857v12c0 .303.134.594.373.808.238.215.562.335.9.335h11.454c.338 0 .662-.12.9-.335.239-.214.373-.505.373-.808v-12c0-.303-.134-.594-.373-.808a1.35 1.35 0 0 0-.9-.335m-8.272-.571h5.09v2.286h-5.09zm8.272 13.714H1.273v-12h1.909v1.714h7.636V2.857h1.91z"
    }, null, -1)
  ]))]))
}
export default { render: render }